import React from "react";

export default function NoData({ text = "No Data Found" }) {
  return (
    <div className="flex justify-center flex-col items-center h-full p-6">
      <img src="/assets/images/nodata.svg" alt="" className="h-20" />
      <p className="text-md font-bold">{text}</p>
    </div>
  );
}
